import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import type { Result } from './type/result.type'

const serviceURL = API.CALCULATION.RESULTS.INDEX

export const useResultStore = defineStore('result', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<Result>({ service: serviceURL, api })

  return {
    ...baseStore
  }
})
